"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redact_1 = require("@nerdwallet/redact");
const redactor = (0, redact_1.createRedactor)({});
exports.default = redactor;
